import {Button, Text} from '#component/base';
import {AuthCTAMessages} from '#component/partial';

import {bodyNotification, notificationWrapper} from '../NotificationTab/NotificationTab.css';

import {ctaPrivacy, mailPrivacy} from './PrivacyTab.css';

const PrivacyTab = () => {
  const handleCopy = () => {
    navigator.clipboard.writeText('hello@tallyhealth.com');
  };
  return (
    <div className={notificationWrapper}>
      <AuthCTAMessages
        title="Privacy"
        titleColor="burgundy"
        titleVariant="heading3"
        className={ctaPrivacy}
        messages={[
          'Your data is your own and if you’d like to delete your information from our database—this includes both your test sample(s) as well as account details—we’re happy to help with your request.',
        ]}
      />
      <Text variant="body" color="doveGray" className={bodyNotification}>
        Simply message us at{' '}
        <a className={mailPrivacy} href="mailto:hello@tallyhealth.com">
          hello@tallyhealth.com{' '}
        </a>
        using the email tied to your account.
      </Text>
      <Button variant="primary" color="burgundy" onClick={handleCopy}>
        Copy E-mail Address
      </Button>
    </div>
  );
};

export default PrivacyTab;
